import { render, staticRenderFns } from "./customs-desc.vue?vue&type=template&id=925971ec&scoped=true"
import script from "./customs-desc.vue?vue&type=script&lang=js"
export * from "./customs-desc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "925971ec",
  null
  
)

export default component.exports